'use client';

import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '../../utils/tailwind';
const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;
const TooltipPortal = TooltipPrimitive.Portal;
const TooltipContent = React.forwardRef<React.ElementRef<typeof TooltipPrimitive.Content>, React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>>(({
  className,
  sideOffset = 4,
  ...props
}, ref) => <TooltipPrimitive.Content ref={ref} sideOffset={sideOffset} className={cn('z-50 overflow-hidden rounded-[4px] bg-gray-900 p-1.5 text-body-2 text-gray-200 bg-opacity-90 whitespace-pre-line', ['animate-in', 'fade-in-0', 'zoom-in-95', 'data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0', 'data-[state=closed]:zoom-out-95', 'data-[side=bottom]:slide-in-from-top-2', 'data-[side=left]:slide-in-from-right-2', 'data-[side=right]:slide-in-from-left-2', 'data-[side=top]:slide-in-from-bottom-2'], className)} {...props} />);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
const TooltipArrow = React.forwardRef<React.ElementRef<typeof TooltipPrimitive.Arrow>, React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Arrow>>(({
  className,
  ...props
}, ref) => <TooltipPrimitive.Arrow ref={ref} className={cn('fill-primary', className)} {...props} />);
TooltipArrow.displayName = TooltipPrimitive.Arrow.displayName;
export { Tooltip, TooltipTrigger, TooltipPortal, TooltipContent, TooltipProvider, TooltipArrow };